import CommonScams from './CommonScams.jsx';

export default CommonScams;